<template>
  <Field
    v-slot="{ errors, meta, field }"
    :name="vid"
    :rules="rules"
    :vid="vid"
    class="column is-12"
  >
    <b-field
      :label="label"
      :message="errors"
      :type="{
        'is-danger': errors && errors.length > 0,
        'is-success': meta.valid,
      }"
      class="file is-primary column is-12"
      grouped
    >
      <template #label>
        <span
          v-if="required"
          class="required"
        >{{ $t("ponctuation.star") }}</span>
        <span class="label">{{ label }}</span>
      </template>
      <b-taginput
        v-if="multiplicity === 'MANY'"
        v-bind="field"
        v-model="numberValue[vid]"
        :placeholder="checker.type === 'IntegerChecker' ? '4' : 4.35"
        :required="required"
        type="text"
        @blur="updateValue"
        @input="updateValue"
      />
      <InputNumber
        v-else
        v-model="numberValue[vid]"
        v-bind="field"
        :format="checker.type === 'FloatChecker' ? 'float' : 'integer'"
        :from="numberValue[vid]"
        :input-type="checker.type === 'FloatChecker' ? 'float' : 'integer'"
        :is-simple-value="true"
        :max="max"
        :min="min"
        @update:number-value="updateValue"
      />
    </b-field>
  </Field>
</template>

<script lang="ts">
import { Field } from "vee-validate";
import { reactive, ref, watch } from "vue";
import InputNumber from "@/components/common/provider/InputNumber.vue";
import useNumber from "@/composable/components/number";

export default {
  name: "OreInputNumber",
  components: {
    InputNumber,
    Field,
  },
  props: {
    checker: {
      type: Object,
      required: false,
    },
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    vid: {
      type: String,
      required: false,
    },
  },
  emits: ["update:value"],
  setup(props, ctx) {
    const val = ref(props.value);
    watch(
      () => props.value,
      (newValue) => {
        val.value = newValue;
      },
      { immediate: true },
    );

    const numberValue = reactive({});
    watch(
      () => [props.vid, val.value],
      ([vid, value]) => {
        if (typeof value === "string") {
          numberValue[vid] = parseFloat(value) || 0;
        }
        else {
          numberValue[vid] = value;
        }
      },
      { immediate: true },
    );

    const { refNumber: min } = useNumber(
      props.checker.min && props.checker.min !== "-Infinity" ? props.checker.min : Number(-Infinity),
    );
    const { refNumber: max } = useNumber(
      props.checker.max && props.checker.max !== "Infinity" ? props.checker.max : Number(Infinity),
    );
    function updateValue(event) {
      if (typeof event == "object") {
        event = (event.value.toString() || "").replace(",", ".");
      }
      ctx.emit("update:value", "" + (event || "").replace(",", "."));
    }

    return {
      val,
      numberValue,
      min,
      max,
      updateValue,
    };
  },
  computed: {
    required: {
      get() {
        return this.checker && this.checker.required;
      },
    },
    multiplicity: {
      get() {
        return this.checker && this.checker.multiplicity === "MANY";
      },
    },
    rules: {
      get() {
        let rules = [];
        if (this.checker) {
          if (this.checker.type === "IntegerChecker") {
            rules.push("integer");
          }
          if (this.checker.type === "FloatChecker") {
            rules.push("float");
          }
          if (this.checker.required) {
            rules.push("required");
          }
        }
        return rules.join("|");
      },
    },
  },
};
</script>

<style scoped>
.required {
  color: rgb(255, 0, 0);
  padding-right: 5px;
  font-size: 150%;
}
</style>
